import { toast } from '@/hooks/use-toast';
import { Check, AlertCircle, AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';
import i18next from 'i18next';

interface ToastOptions {
    title?: string;
    description: string;
    duration?: number;
    action?: {
      label: string;
      onClick: () => void;
    };
    onOpenChange?: (open: boolean) => void;
    variant?: 'default' | 'destructive';
    className?: string;
  }

export const showToast = {
  success: ({ 
    title = i18next.t('common.success', 'Success'), 
    description, 
    duration = 1000,
    action,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'default',
      className: 'border-green-200 bg-green-50',
      action,
      onOpenChange
    });
  },

  error: ({ 
    title = i18next.t('common.error', 'Error'), 
    description, 
    duration = 2000,
    action,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'destructive',
      action,
      onOpenChange
    });
  },

  warning: ({ 
    title = i18next.t('common.warning', 'Warning'), 
    description, 
    duration = 2000,
    action,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'default',
      className: 'border-yellow-200 bg-yellow-50',
      action,
      onOpenChange
    });
  }
}; 